import * as _ from 'lodash'
import {
  ISearch,
  ISearchProfile,
  ISearchProvider,
  HorizAlignment,
  SearchProviderFieldType,
  ISearchProviderField, ISearchRequestSubset, IProfileFilter, ITree, ISearchSort, ISearchRenderOptions
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";
import {WB_DomainItemRow, WB_DomainRow} from "../PA.Core/PAdbSchemaRows";
import {PAdbContext} from "../PA.Core/PAdbContext";
import {esWB_Domain, esWB_Domain_Item} from "../PA.Core/PAdbSchema";


export interface IDomainItemSearchByListCreateOptions {
  sName: string,
  domainItems?: WB_DomainItemRow[],
  domainId?: string,
  domainIds?: string[],
  bUseIdAsKey?: boolean
}

const vUI_DomainItem_Search_Fields: {[id:string]: ISearchProviderField } = {
  WB_DOMITEM_ID:                {type: SearchProviderFieldType.number, renderOptions: { columnName: 'WB Domain Item Id', columnResourceName: 'colDomainItemId', alignment: HorizAlignment.Center}, domainOptions: {}},
  DOMAIN_ID:                    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Domain Id', columnResourceName: 'colDomainId', alignment: HorizAlignment.Right}, domainOptions: {}},
  DOMAIN_ITEM_ID:               {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Domain Item Id', columnResourceName: 'colDomainItemId', alignment: HorizAlignment.Right}, domainOptions: {}},
  DOMAIN_ITEM_NAME:             {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Domain Item Name', columnResourceName: 'colDomainItemName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}}
}


const   Domain_keyFields_ByWBId =
    {id:    'WB_DOMITEM_ID',
     id_ui: 'DOMAIN_ITEM_ID',
     name:  'DOMAIN_ITEM_NAME'}

const   Domain_keyFields_ById =
    {id:    'DOMAIN_ITEM_ID',
     id_ui: 'DOMAIN_ITEM_ID',
     name:  'DOMAIN_ITEM_NAME'}


class DomainItemSearchByListSearchProvider
  implements  ISearchProvider {

  opts: IDomainItemSearchByListCreateOptions

  constructor(options: IDomainItemSearchByListCreateOptions){
    this.opts = options || {sName: "Unknown"}
  }

  get keyFields() {
    if(this.opts.bUseIdAsKey){
      return Domain_keyFields_ById
    } else {
      return Domain_keyFields_ByWBId
    }
  }

  get searchProviderFields(){
    return vUI_DomainItem_Search_Fields
  }

  search(requestSpec: ISearchRequestSubset): Promise<any[]> {
    const self = this

    return new Promise<any[]>((resolve, error) => {

      if(!_.isEmpty(self.opts.domainItems)){
        resolve(self.opts.domainItems)
        return
      }

      let domainIds: string[] = []
      if(!_.isEmpty(self.opts.domainId)){
        domainIds.push(self.opts.domainId)
      }

      if(!_.isEmpty(self.opts.domainItems)){
        domainIds.push.apply(domainIds, self.opts.domainItems)
      }

      if(_.isEmpty(domainIds)){
        resolve([])
        return
      }

      let aDbContext = new PAdbContext()
      aDbContext.findAll(esWB_Domain, {where: {DOMAIN_ID: {in: domainIds}, DELETED_IND: {neq: '1'}} })
        .then((arrDomains:WB_DomainRow[]) => {

          let arrDomainWBIds: number[] = []

          //
          if(_.isEmpty(arrDomains)) {
            arrDomainWBIds = [-777]
          } else {
            arrDomainWBIds = _.map(arrDomains, (aDomainRow: WB_DomainRow) => { return aDomainRow.cif.WB_DOM_ID})
          }

          return aDbContext.findAll(esWB_Domain_Item, {where: {WB_DOM_ID: {in: arrDomainWBIds}, EXCLUDE_IND: {in: ['0','']}, DELETED_IND: {neq: '1'}}})

        })
        .then((results: WB_DomainItemRow[]) => {
            results = _.sortBy(results, ['DOMAIN_ITEM_SORT','DOMAIN_ITEM_NAME'])
            resolve(results)
        })
        .catch((err) => {
          error(err)
        })
    })
  }

}


export class DomainItemSearchProfileByList
  implements  ISearchProfile {

  aSearchProvider: ISearchProvider = undefined

  profileId = "default"
  profileName = "AutoSearch Only"
  renderOptions = { ui5ResourceId: "DomainItemSearchByListProfile" }

  profileFilter: IProfileFilter[] = []

  profileDisplayFields = [
    'DOMAIN_ITEM_NAME','DOMAIN_ITEM_ID'
  ]

  profileTreeIdDefault = "default"
  profileTrees: ITree[] = [
    {treeId: "default",
      treeName: "By Hierarchy",
      nodeProviders: [ new ColumnNodeProvider(['TREE_PATH'], {defaultValues: "Domain Item Tree Path not set"})],
      renderOptions: {}}
  ]

  // Do sorting last.. not necessary for phase 1
  profileSortIdDefault = ""    //string;
  profileSorts: ISearchSort[] = [] //ISearchSort[];


  constructor(options: IDomainItemSearchByListCreateOptions){
    this.aSearchProvider = new DomainItemSearchByListSearchProvider(options)
  }

  get profileSearchProvider(){ return this.aSearchProvider }

}


export class DomainItemSearchByList
  implements  ISearch {

  opts: IDomainItemSearchByListCreateOptions
  autoSearch: boolean;
  autoSearchProfileId: string;
  renderOptions: ISearchRenderOptions;
  searchName: string;
  searchProfileIdDefault: string;
  searchProfiles: ISearchProfile[];

  constructor(options: IDomainItemSearchByListCreateOptions){
    this.opts = options || {sName: "Select"}
    this.searchName = this.opts.sName
    this.renderOptions = { ui5ResourceId: "DomainItemSearchByList"}
    this.searchProfileIdDefault = "default"
    this.searchProfiles = []
    this.autoSearch = true

    this.searchProfiles = [ new DomainItemSearchProfileByList(this.opts) ]
  }

}

